import { apiRequest, authRequest } from '../config/api';

// Stats API endpoints
export const statsAPI = {
  // Admin endpoints (token required)
  updateStat: (statId, statData) => authRequest(`/Stats/update/${statId}`, {
    method: 'PUT',
    body: JSON.stringify(statData),
  }),
  
  getAllStats: () => authRequest('/Stats/get', {
    method: 'GET',
  }),
  
  // Public endpoints (no token required)
  getVisibleStats: () => apiRequest('/Stats/get_active', {
    method: 'GET',
  }),
}; 